import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import { globalStyles as styles } from '../style/gstheme';
import TitledPanel from '../TitledPanel';
import TitledTextField from '../TitledTextField';
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from '../utils/constants';
import { fullySanitiseText, lightSanitiseText } from '../utils/utils';
import LabelledSwitch from '../LabelledSwitch';

class SaveQueryDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isValidIRI: true,
            open: false,
            title: "",
            description: "",
            isReport: false
        };
    }

    handleTitleChange = (event) => {
        const t = event.target;
        const cleanText = fullySanitiseText(t.value);
        this.setState({ [t.name]: cleanText });
    };

    handleDescriptionChange = (event) => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value);
        this.setState({ [t.name]: cleanText });
    };

    handleReportChange = (isReport) => this.setState({ isReport });

    handleClickOpen = () => {
        const qd = this.props.queryDetails;
        this.setState({
            open: true,
            ...(qd) && {
                title: qd.title[this.props.defaultLang] || "",
                description: qd.description[this.props.defaultLang] || "",
                isReport: qd.isReport || false
            }
        });
    };

    saveQuery = () => {
        const { title, description, isReport } = this.state;
        this.exitSaveQuery();
        this.props.onSaveQuery({
            title,
            description,
            isReport
        });
    };

    exitSaveQuery = () => this.setState({
        open: false,
        title: "",
        description: "",
        isReport: false
    });

    render() {

        const { classes, name, reportOption, disabled, defaultLang } = this.props;
        const { title, description, isReport } = this.state;

        return (
            <React.Fragment>
                <SecondaryButton
                    dataTest="save-query"
                    disabled={disabled}
                    endIcon={<SaveIcon />}
                    onClick={this.handleClickOpen}>{name || "Save Query"}</SecondaryButton>
                <Dialog
                    data-test="save-query-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paper: classes.paper,
                        paperWidthMd: classes.mediumDialog
                    }}
                    className={classes.dialog}
                    open={this.state.open}
                    onClose={this.exitSaveQuery}
                    aria-labelledby="savequery-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="savequery-dialog-title">{name || "Save Query"}</DialogTitle>
                    <DialogContent>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="title"
                                name="title"
                                title="Title"
                                autoFocus
                                placeholder="Enter title for query"
                                required={true}
                                lang={defaultLang}
                                text={title}
                                maxLength={MAX_TITLE_LENGTH}
                                onChange={this.handleTitleChange} />
                            <TitledTextField
                                margin
                                dataTest="description"
                                name="description"
                                title="Description"
                                multiline={true}
                                required={false}
                                lang={defaultLang}
                                placeholder="Enter description for query"
                                text={description}
                                maxLength={MAX_DESCRIPTION_LENGTH}
                                onChange={this.handleDescriptionChange} />
                            {reportOption &&
                                <TitledPanel margin title="Use as a Report">
                                    <LabelledSwitch
                                        dataTest="use-as-report"
                                        checked={isReport}
                                        handleChange={this.handleReportChange}
                                        label="Yes" />
                                </TitledPanel>
                            }
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitSaveQuery} />
                        <PrimaryButton disabled={title === ""} onClick={this.saveQuery}>Save</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

SaveQueryDialog.defaultProps = {
    reportOption: false,
    disabled: false
};

SaveQueryDialog.propTypes = {
    name: PropTypes.string,
    disabled: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    classes: PropTypes.object,
    queryDetails: PropTypes.object,
    reportOption: PropTypes.bool,
    onSaveQuery: PropTypes.func.isRequired
};

export default withStyles(styles)(SaveQueryDialog);